<template>
    <div>
        <MainModal 
            :show-modal="showModal" :footer="false" :close-btn="false"
            size="sm" @close="$emit('cancel')"
        >
            <template #body>
                <div class="modal__wrapper--onboarding">
                    <div class="modal--section">
                        <div class="mb--20 mt--20">
                            <PageSpinner />
                        </div>
                    </div>
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import MainModal from "./MainModal.vue";
import PageSpinner from "../loaders/PageSpinner.vue";

export default {
    name: "PageLoading",

    components: { MainModal, PageSpinner },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["cancel"],
};
</script>